import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { CopilotButton } from '@/components/CopilotDrawer';
import { NewSearchInput } from '@/components/NewSearchInput';
import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { useQueryParamOption } from '@/hooks/queryParamOption';
import { ViewType, viewTypes } from '@/util/linkTypes';
import { getViewType } from '../NewMultiProjectPage';

export interface SearchHeaderParams {
  shouldUseTypeahead: boolean;
}

export const SearchHeader: FC<SearchHeaderParams> = ({ shouldUseTypeahead }) => {
  const { hasAccountFeature } = useDbtCloudAccount();
  const isCatalogPreviewEnabled = hasAccountFeature('explorerAccountUI');

  const [_viewParam] = useQueryParamOption({
    param: 'view',
    options: viewTypes,
    validateOption: getViewType,
  });
  const viewParam: ViewType = _viewParam ?? 'list';

  const location = useLocation();
  const isLineagePath = location.pathname.includes('/lineage/');

  if (!isCatalogPreviewEnabled || viewParam === 'lineage' || isLineagePath) {
    return null;
  }

  return (
    <header className="flex h-[57px] flex-row items-center justify-between border-b border-borderMuted bg-bgRaised">
      <div className="invisible" />
      <NewSearchInput shouldUseTypeahead={shouldUseTypeahead} />
      <div className="mr-4">
        <CopilotButton />
      </div>
    </header>
  );
};
